import { format as cf } from "currency-formatter";

const format = (input: number) : string => {
  return cf(input/100, { code: "USD"});
};

export default format;